import { Flex } from 'antd';
import { FC, ReactNode } from 'react';

import { Image } from '@/shared/ui';

interface Props {
  title?: string;
  message: ReactNode;
  actionButtons: ReactNode;
}

export const UnavailabilityPage: FC<Props> = ({ title, message, actionButtons }) => {
  return (
    <Flex justify="space-between" className="service-unavailable__container">
      <div className="service-unavailable">
        <div>
          <Image src="/images/criss-cross_gray.svg" alt="Criss Cross" width={40} height={40} />
        </div>
        <div className="service-unavailable__content">
          {title && <p>{title}</p>}
          {message}
        </div>
      </div>
      <div className="service-unavailable__bottom">{actionButtons}</div>
    </Flex>
  );
};
